'use client';

import { createContext, useContext, useEffect, useState } from "react";
import axiosRequest from "../api/axiosRequest";
import toast from "react-hot-toast";

import PopupOverlay from "../components/PopupOverlay";

const us = "/assets/flags/US.png";
const ind = "/assets/flags/IN.png";
const appContext = createContext();

export const useAppContext = () => {
  return useContext(appContext);
};

export function AppContextProvider({ children }) {
  const [popup, setPopup] = useState(null);

  const showPopup = ({ title,
    message,
    onConfirm,
    onCancel,
    confirmText = "OK",
    cancelText = "Cancel",
    type = "default",
    loading }) => {
    setPopup({
      title,
      message,
      onConfirm,
      onCancel,
      confirmText,
      cancelText,
      type,
      loading,
    });
  };

  const closePopup = () => setPopup(null);

  const basicCountries = [
    { flag: us, name: "United States", phonecode: "1" },
    { flag: ind, name: "India", phonecode: "91" },
  ];

  const [countries, setCountries] = useState(basicCountries);

  async function getCountries({ children }) {
    try {
      const response = await axiosRequest("public/get-country", "GET");

      if (response.data?.status) {
        setCountries(response.data.data.countryData || basicCountries);
      } else {
        if (response?.data?.message) {
          // toast.error(response?.data?.message);
          console.error("country error:", response?.data?.message);
        }
      }
    } catch (error) {
      // toast.error(
      //   "An error occurred while getting countries. Please try again or contact support."
      // );
      console.error("country error:", error);
    }
  }

  // useEffect(() => {
  //   getCountries();
  // }, []);

  return (
    <appContext.Provider
      value={{ showPopup, closePopup, countries, setCountries }}
    >
      {children}
      {popup && <PopupOverlay {...popup} closePopup={closePopup} />}
    </appContext.Provider>
  );
}
